import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M3 21h18v-2H3v2zm6-4h12v-2H9v2zm-6-4h18v-2H3v2zm6-4h12V7H9v2zM3 3v2h18V3H3z"
}), 'FormatAlignRightOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/FormatAlignRightOutlined.js
// module id = 3810
// module chunks = 2